/* eslint-disable no-unused-vars */
import { ExploreFilterSchemaFields } from "@modules/new-explore/types";
import { useExplore } from "@modules/new-explore/hooks/useExplore";
import classNames from "classnames";
import Tag from "@shared/components/tag/Tag";
import { TAG_COLOR, TAG_SIZE, TAG_STYLE, TAG_TYPE } from "@shared/components/tag";
import { useRouter } from "next/router";
import { EXPLORE_SLUG } from "types/api/explore";
import { FC } from "react";

interface Props {
  top?: string;
}
const ActiveFilters: FC<Props> = () => {
  const { query } = useRouter();
  const { removeFilterByValue, visibleActiveFilters, getTermLabel } =
    useExplore();

  const slug = query.slug || EXPLORE_SLUG.COURSE;
  if (!visibleActiveFilters) return <></>;
  const filterCount = Object.values(visibleActiveFilters).reduce(
    (prev, item) => prev + item.filter_value.length,
    0
  );

  const filtersArray = Object.entries(visibleActiveFilters);
  return (
    <div className=" border-b border-b-zinc-200">
      <div
        className={classNames(
          "flex gap-1.5  flex-wrap",
          filterCount > 0 ? "py-6" : "pb-6"
        )}
      >
        {filtersArray.map(([filterName, filterItem]) =>
          (filterItem.filter_value || [])?.map?.(
            (
              filterVal: { label: string; id: string; parentId?: number },
              index
            ) => {
              const { label, id } = filterVal;
              const parentFilterLabel = filterItem.filter_label;
              const showingLabel =
                label ||
                (filterItem.filter_value?.length === 1 &&
                  (filterName === "term" ? getTermLabel() : parentFilterLabel));
              return (
                <Tag
                  key={`${index}.${id}`}
                  handleCloseClick={() =>
                    removeFilterByValue(
                      filterName as ExploreFilterSchemaFields,
                      id
                    )
                  }
                  showTagClose={true}
                  id={filterName}
                  style={TAG_STYLE.OUTLINE}
                  color={TAG_COLOR.DEFAULT}
                  type={TAG_TYPE.ROUNDED}
                  size={TAG_SIZE.MEDIUM}
                >
                  {showingLabel}
                </Tag>
              );
            }
          )
        )}
      </div>
    </div>
  );
};

export default ActiveFilters;
